module.exports = __webpack_public_path__ + "static/media/template1-carousel.e5614303.webp";